(function(){
  function onReady(fn){ if(document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function suffix(n){return (n%10==1&&n%100!=11)?'st':(n%10==2&&n%100!=12)?'nd':(n%10==3&&n%100!=13)?'rd':'th';}
  function fmt(d){var days=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];var months=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];return days[d.getDay()]+' . '+months[d.getMonth()]+' . '+d.getDate()+' '+suffix(d.getDate())+' , '+d.getFullYear()+' | 11:11 am EST';}
  onReady(function(){
    var d=new Date(); d.setDate(d.getDate()-2);
    var txt=fmt(d);
    var rx=/[A-Z][a-z]{2}\s*\.\s*[A-Z][a-z]{2}\s*\.\s*\d{1,2}\s*(?:st|nd|rd|th)\s*,\s*20\d{2}\s*\|\s*11:11\s*am\s*EST/g;
    var walker=document.createTreeWalker(document.getElementById('lower-back-report-native')||document.body, NodeFilter.SHOW_TEXT);
    var nodes=[], node; while((node=walker.nextNode())) nodes.push(node);
    nodes.forEach(function(n){ if(rx.test(n.nodeValue)){ n.nodeValue=n.nodeValue.replace(rx,txt); } });
  });
})();

(function(){
  function onReady(fn){ if(document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  onReady(function(){
    var cta=document.getElementById('ix4a36-4-5');
    if(!cta) return;
    var trigger=document.getElementById('itksswy') || document.querySelector('[data-original-image*="introducing"], .htb02-section-image');
    var ticking=false;
    function threshold(){
      if(!trigger) return Math.round(window.innerHeight * 0.85);
      var top=trigger.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0);
      return Math.max(360, top - window.innerHeight * 0.55);
    }
    function update(){
      ticking=false;
      var y=window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.classList.toggle('bs-show-sticky-cta', y > threshold());
    }
    function request(){ if(!ticking){ ticking=true; window.requestAnimationFrame(update); } }
    window.addEventListener('scroll', request, {passive:true});
    window.addEventListener('resize', request);
    update(); setTimeout(update,250); setTimeout(update,1000);
  });
})();

(function(){
  var root=document.getElementById('lower-back-report-native');
  var dest='https://daywick.com/pages/back-support-offer';
  function shouldRoute(el){
    if(!el) return false;
    var txt=((el.getAttribute('data-text-value')||'')+' '+(el.textContent||'')+' '+(el.getAttribute('title')||'')+' '+(el.getAttribute('action')||'')).toLowerCase();
    return txt.indexOf('get ')>-1 || txt.indexOf('try ')>-1 || txt.indexOf('order')>-1 || txt.indexOf('check availability')>-1 || txt.indexOf('56%')>-1 || txt.indexOf('today only')>-1 || txt.indexOf('route')>-1;
  }
  document.addEventListener('click',function(e){
    var el=e.target.closest && e.target.closest('a,button');
    if(!el || (root && !root.contains(el))) return;
    var href=el.getAttribute('href')||'';
    if(href && href.indexOf('#')!==0 && href.indexOf('javascript:')!==0) return;
    if(shouldRoute(el)){e.preventDefault(); window.location.href=dest;}
  },true);
})();

/* Daywick BareSupport desktop sidebar DOM restore to original article/sidebar wrapper v2 2026-06-17 */
(function(){
  function ready(fn){ if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  function repair(){
    var article=document.getElementById('ipgb6');
    var bodyCol=document.getElementById('ilqbm');
    var sidebar=document.getElementById('iaxmo');
    if(!article || !sidebar) return;
    if(!bodyCol){ bodyCol=document.createElement('div'); bodyCol.id='ilqbm'; article.insertBefore(bodyCol, article.firstChild); }
    Array.prototype.slice.call(article.children).forEach(function(child){
      if(child !== bodyCol && child !== sidebar){ bodyCol.appendChild(child); }
    });
    if(bodyCol.parentElement !== article) article.insertBefore(bodyCol, article.firstChild);
    if(sidebar.parentElement !== article) article.appendChild(sidebar);
    if(bodyCol.nextElementSibling !== sidebar) article.insertBefore(sidebar, bodyCol.nextSibling);
    sidebar.setAttribute('data-daywick-sidebar-original-parent','ipgb6');
    article.setAttribute('data-daywick-sidebar-original-layout','1');
    bodyCol.setAttribute('data-daywick-main-column-restored','1');
  }
  ready(function(){ repair(); setTimeout(repair, 100); setTimeout(repair, 500); setTimeout(repair, 1200); });
})();

/* Direct sticky CTA visibility toggle for advertorial */
(function(){
  var root=document.getElementById("lower-back-report-native");
  if(!root)return;
  var sticky=root.querySelector(".sticky, #ix4a36-4-5");
  if(!sticky)return;
  function updateAdvSticky(){
    var scrolled=window.scrollY||document.documentElement.scrollTop||0;
    var show=scrolled>700;
    root.classList.toggle("sticky-visible",show);
    if(show){
      sticky.style.setProperty("visibility","visible","important");
      sticky.style.setProperty("opacity","1","important");
      sticky.style.setProperty("transform","translateY(0)","important");
      sticky.style.setProperty("pointer-events","auto","important");
    }else{
      sticky.style.setProperty("visibility","hidden","important");
      sticky.style.setProperty("opacity","0","important");
      sticky.style.setProperty("transform","translateY(110%)","important");
      sticky.style.setProperty("pointer-events","none","important");
    }
  }
  window.addEventListener("scroll",updateAdvSticky,{passive:true});
  window.addEventListener("resize",updateAdvSticky);
  updateAdvSticky();
  setTimeout(updateAdvSticky,350);
})();

/* Inject CSS overrides at runtime to bypass CDN cache */
(function(){
  var style=document.createElement("style");
  style.id="daywick-lumbar-adv-runtime-overrides";
  style.textContent=[
    "#lower-back-report-native #ix4a36-4-5{background-color:#f1c967!important;}",
    "#lower-back-report-native #ix4a36-4-5 a,#lower-back-report-native #ix4a36-4-5 a:visited{color:#000!important;-webkit-text-fill-color:#000!important;}",
    "#lower-back-report-native [data-gjs-type][class*='gjs-selected']{outline:none!important;}",
    "#lower-back-report-native [data-gjs-type][class*='gjs-comp-selected']{outline:none!important;}"
  ].join("\n");
  document.head.appendChild(style);
})();

/* dw-mikke-report-sticky-final-20260620 start */
(function(){function ready(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn);else fn();}ready(function(){var root=document.getElementById('lower-back-report-native');if(!root)return;var sticky=root.querySelector('#ix4a36-4-5, .sticky');if(!sticky)return;function update(){var y=window.scrollY||document.documentElement.scrollTop||0;var show=y>420;root.classList.toggle('sticky-visible',show);sticky.style.setProperty('display','flex','important');sticky.style.setProperty('visibility',show?'visible':'hidden','important');sticky.style.setProperty('opacity',show?'1':'0','important');sticky.style.setProperty('transform',show?'translateY(0)':'translateY(110%)','important');sticky.style.setProperty('pointer-events',show?'auto':'none','important');}window.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update);update();setTimeout(update,250);setTimeout(update,1000);});})();
/* dw-mikke-report-sticky-final-20260620 end */
